module.exports = __webpack_public_path__ + "img/9.49d227fb.svg";